<template>
  <div class="bgbox">
    <div class="meterials">
    <div class="flex">
        <span style="color:#0d6efd;cursor: pointer;" @click="handleback">&lt; - {{$t("message.productlist")}}  </span>
        <span> / {{product.productName}}</span>
    </div>
    <div class="flex pack">
        <div class="flex nameboxs">
            <div class="imgbox">
                 <el-image class="goodsimg" :src="currenturl" :preview-src-list="[currenturl]" />
            </div>
            <p class="product">{{product.productName}} <span v-if="infoName" @click="init()">/ {{infoName}}</span></p>
        </div>
        <el-button @click="unpack(item,true)">{{$t("message.pack")}}</el-button>
    </div>
    <div class="flex packlist">
         <div v-if="detailimg.length>0" class="itemlist" >
             <div v-for="(item,index) in detailimg" :key="index" class="itembg" >
             <div class="packpic">
                <img :src="item.imagePath" alt="">
            </div>
           <div>
             <p class="proname">{{item.imageName}}</p>
            <p>{{$t("message.volume")}}:{{item.size}}M</p>
            <p @click="handleupload(item.imagePath)" style="color:#0D6EFD">{{$t("message.click")}}</p>
           </div>
        </div>
         </div>
       <div v-else class="itemlist" >
         <div v-for="(item,index) in product.imageInfoList" :key="index"  @click="detail(item)" class="itembg">
             <div class="packpic">
                <img src="../../assets/folder.png" alt="">
            </div>
           <div>
             <p class="proname">{{item.infoName}}</p>
            <p @click.stop="unpack(item,false)" style="color:#0D6EFD">{{$t("message.click")}}</p>
           </div>
        </div>
       </div>
    </div>
  </div>
  </div>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed, getCurrentInstance } from 'vue';
import { productInfoApi,producttZipApi,producttImageApi,producttSingleApi } from "@/api/index.js";
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const { proxy } = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const handleback = ()=>{
    router.back()
}
onMounted(() => {
  init()
})
// 下载图片
const handleupload = (url)=>{
    let basePath = url.replace('https://zhonggu-com.oss-cn-guangzhou.aliyuncs.com/', "")
    producttSingleApi({basePath})
    .then((res) => {        
      window.open(res)
      ElMessage.success('下载成功');
    })
    .catch((err) => {
      console.log(err);
    });

}
// 打包下载
const unpack=(item,type)=>{
    let data = {}
    if (type) {
        data={
            id:product.value.id
        }
    }else{
      data = {id:product.value.id,type:item.infoName}
    }
producttZipApi(data)
    .then((res) => {                
      window.open(res)
      ElMessage.success('下载成功');
    })
    .catch((err) => {
      console.log(err);
    });
}
// 进入详情
let detailimg = ref([])
let infoName = ref('')
let currenturl = ref('')
const detail = (data)=>{
    let params = {
        id:currentid.value,
        type:data.infoName
    }
producttImageApi(params)
    .then((res) => {        
      detailimg.value = res.imageList;
      infoName.value = res.name
    })
    .catch((err) => {
      console.log(err);
    });
}
let product = ref({})
let currentid = ref(null)
const init = ()=>{
const params = JSON.parse(route.query.formData)
const id = route.query.id
currentid.value = route.query.id
let data = {
    id,
    keywords:params.keywords,
    classId:params.classId,
    pid:params.pid,
}
productInfoApi(data)
    .then((res) => {        
      product.value = res;
      infoName.value = ''
      detailimg.value = [];
      currenturl.value = res.imageList[0]      
    })
    .catch((err) => {
      console.log(err);
    });
}

</script>
<style scoped lang='scss'>
.meterials{
    width: 36%;
    background-color: #fff;
    padding: 10px 20px;
}
.bgbox{
    background-color: #ededed;
    display: flex;
    justify-content: center;
    padding: 30px 0;
    min-height: 858px;
}
.flex{
    display: flex;
}
.pack{
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #dee2e6;
    align-items: center;
    margin: 20px 0;
}
.imgbox{
    width: 77px;
    height: 77px;
    margin-right: 20px;
}
.nameboxs{
    align-items: center;
}
.product{
    color: #212529;
    font-weight: 500;
}
.itembg{
    width: 23.2%;
    display: flex;
    margin-right: 10px;
    flex-direction: column;
    border: 1px solid #dee2e6;
    align-items: center;
    padding: 20px 0 5px;
    font-size: 13px;
    margin-bottom: 10px;
    border-radius: 5px;
    cursor: pointer;
}
.packlist{
    flex-wrap: wrap;
}
.packpic{
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
}
.itemlist{
width: 100%;
display: flex;
flex-wrap: wrap;
}
.proname{
    font-weight: 500;
    line-height: 30px;
}
.goodsimg{
    width: 100%;
    height: 100%;
}
</style>